import { kitchenServiceUrl } from '../config/config';

const getKitchens = async (authorizationToken, params) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/kitchen?${params?.toString()}`, { 
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const getKitchensByChef = async (chefId, authorizationToken) => {
      try {
        const response = await fetch(`${kitchenServiceUrl}/kitchens/${chefId}`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
          },
        });
        if (!response.ok) {
          throw new Error('Request failed');
        }
        const responseData = await response.json();
        return responseData;
      } catch (error) {
        throw new Error(error.message);
      }
    };
  
  const getKitchenDetails = async (kitchenId, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/kitchen/${kitchenId}`, { 
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const getKitchenSetupData = async (chefId, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/kitchen/setup/${chefId}`, { 
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const saveKitchenData = async (kitchenData, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/kitchen`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
        body: JSON.stringify(kitchenData)
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const saveMenuData = async (menuData, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/menu`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
        body: JSON.stringify(menuData)
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const saveMenuItemData = async (menuItemData, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/menuitem`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
        body: JSON.stringify(menuItemData)
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const removeMenu = async (menuId, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/menu/${menuId}`, { 
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        }
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const removeMenuItem = async (menuItemId, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/menuitem/${menuItemId}`, { 
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        }
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const closeKitchenByChef = async (chefId, authorizationToken) => {
    try {
      const response = await fetch(`${kitchenServiceUrl}/kitchen/close`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authorizationToken}`, // Add the Bearer token to the header
        },
        body: JSON.stringify(chefId)
      });
      if (!response.ok) {
        throw new Error('Request failed');
      }
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw new Error(error.message);
    }
  };
  
export { 
  getKitchens,
  getKitchensByChef,
  getKitchenDetails as getKitchenDetails, 
  getKitchenSetupData, 
  saveKitchenData, 
  saveMenuData,
  saveMenuItemData, 
  removeMenu,
  removeMenuItem,
  closeKitchenByChef,
};